__turbopack_context__.v({
  "arrow": "_6iSANa_arrow",
  "button": "_6iSANa_button",
  "container": "_6iSANa_container",
  "dropdown": "_6iSANa_dropdown",
  "isBouncing": "_6iSANa_isBouncing",
});
